<template>
    <v-container class="app-page-container">
    <v-card>
        <v-card-title>
            Cognitive tests
        </v-card-title>
        <v-card-text>
            <v-expansion-panels v-model="panels" multiple flat class="px-6">
                <v-expansion-panel v-for="(ptest, index) in psychotests.tests" :key="index">
                    <v-expansion-panel-header>
                        <v-row>
                            <v-col cols="4">
                                <h3>{{ptest.test_name}} ({{ptest.test_count}}x)</h3>
                            </v-col>
                            <v-col cols="3">
                                <h3>top score: {{ptest.max_score}}</h3>
                            </v-col>
                            <v-col cols="3" class="course-additional-activities background-transparent shadow-none">
                                <v-btn x-small  @click="startTest(ptest.id)">Start</v-btn>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content v-for="(attempt, index2) in ptest.attempts" :key="index2">
                        <v-row>
                            <v-col cols="4">
                                {{ attempt.time_start}}
                            </v-col>
                            <v-col cols="3">
                               score: {{ attempt.score}}
                            </v-col>
                            <v-col cols="3"></v-col>
                            <v-col cols="1"></v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card-text>
    </v-card>
</v-container>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            psychotests: [],
            panels: [0]
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            axios.get('/get-my-psycho-tests', this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    this.psychotests = res.data
                    const bc = [ { text: 'Cognitive tests', href: '/cognitive_tests/' }, ]
                    this.$store.commit('setBreadCrumbs',bc)                        
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        startTest(_id) {
            this.$router.push({name:'cognitive_test', params: {id : _id}})  
        }
    }
}
</script>